import { render } from "./ViewDataset.vue?vue&type=template&id=6f56cc98&scoped=true"
import script from "./ViewDataset.vue?vue&type=script&lang=js"
export * from "./ViewDataset.vue?vue&type=script&lang=js"

import "./ViewDataset.vue?vue&type=style&index=0&id=6f56cc98&lang=sass&scoped=true"

import exportComponent from "C:\\yb\\work\\website\\yunyu2021\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f56cc98"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn,QIcon});qInstall(script, 'directives', {ClosePopup});
